import {
  CommonResponse,
  MEMBER_CREATE_ORDER_WECHATJS,
  MEMBER_CREATE_ORDER_WECHATQR,
  MEMBER_ORDERS,
  MEMBER_PRE,
  netClient,
  GET_COUPON,
  GET_COUPON_BY_SCENE,
  GIVE_COUPON_By_SECNE
} from '@/apis/api'
import type { CreateOrderNativeResponse, CreateWechatOrderResponse, CheckNativePaidDTO } from '../payment'
import { useLocalStorage } from '@vueuse/core'
import {
  CACHE_KEY_SHOW_PHONE_BIND,
  CACHE_KEY_SHOW_THANKS,
  CACHE_KEY_SHOW_ZHONGYUAN,
  CACHE_KEY_SHOW_RENEW_MENTION
} from '@/constants'
import { computed, ref } from 'vue'
import { type UserMinDTO, getCurrentUser } from '../user/users'
export interface GetPreMembershipPlanResponse {
  plans: Array<MemberPlanDTO>
  couponUsages: Array<CouponUsageDTO> // 添加优惠券信息，如果该优惠券已经被用掉或者过期，则该优惠券不展示。
  membership: MembershipDTO
  registerDays: number
  lifeCount: number
  serviceJoinCount: number
}

export interface MemberPlanDTO {
  id: string
  country: string
  name: string
  priceAmount: number
  priceCurrency: string
  originalPriceAmount: number
  originalPriceCurrency: string
  years: number
  months: number
  createdAt: number
  updatedAt: number
  updatedBy: string
  discount: number
}

export interface MembershipDTO {
  id: string
  userId: string
  state: number
  capUsage: MemberCapUsage
  storageCap: number
  firstActiveDate: number
  recentOrderId: string
  memberDays: number
  expireDate: number
  createdAt: number
}

export interface MemberCapUsage {
  storageUsage: number
  picAiUsage: number
  regUsage: number
  themeUsage: number
  smsPushed: number
  wechatPushed: number
  appPushed: number
  emailPushed: number
}

export function getMemberPre(country: string) {
  return netClient.request<CommonResponse<GetPreMembershipPlanResponse>>(MEMBER_PRE, 'get', { country: country })
}

export interface CreateWechatOrderCommand {
  planId: string
  miniApp: boolean
  couponUsageId: string
}

export interface MemberOrderNativeCommand {
  planId: string
  couponUsageId: string
}

export function createMemberJsWechatOrder(orderCommand: CreateWechatOrderCommand) {
  return netClient.request<CommonResponse<CreateWechatOrderResponse>>(
    MEMBER_CREATE_ORDER_WECHATJS,
    'post',
    orderCommand
  )
}

export function createMemberWechatOrderQR(orderCommand: MemberOrderNativeCommand) {
  return netClient.request<CommonResponse<CreateOrderNativeResponse>>(
    MEMBER_CREATE_ORDER_WECHATQR,
    'post',
    orderCommand
  )
}

export function checkOrderPaid(url: string, orderNo: string) {
  return netClient.request<CommonResponse<CheckNativePaidDTO>>(url, 'get', { orderNo: orderNo })
}

export interface PaymentOrderDTO {
  id: string
  amount: number
  currency: string
  planId: string
  plan: MemberPlanDTO
  userId: string
  payChannel: string
  coinAccountId: string
  coinAmount: number
  state: number
  startDate: number
  endDate: number
  wechatOrderNo: string
  alipayOrderNo: string
  stripeOrderNo: string
  createdAt: number
  updatedAt: number
  expiredAt: number
  orderType: number // 订单类型，见PaymentType定义, 按数字判断
  goodId: string
  summary: string // 订单概述 - 购买花圈挽联时，标题写这个
}

// PaymentType {
//   UNKNOWN(0),
//   MEMBERSHIP(1), // 会员
//   MISSBEAN(2), // 思念豆
//   WREATH(3), // 送花圈
//   COUPLET(4); // 送挽联
// }

export interface MemberOrderPayResponse {
  id: string
  pageSize: number
  total: number
  items: Array<PaymentOrderDTO>
}

export function getMemberPayOrder(last: string | null, pageSize: number) {
  return netClient.request<CommonResponse<MemberOrderPayResponse>>(MEMBER_ORDERS, 'get', {
    last: last,
    pageSize: pageSize
  })
}
export interface CouponDTO {
  id: string
  name: string // 优惠券名称
  description: string // 描述
  discountType: number // 折扣方式 0 - 固定金额折扣  1 - 百分比折扣
  discountPercent: number // 0 - 折扣比例 如75 为七五折，原价的75%
  discountAmount: number // 1 - 折扣金额，减去 x 分
  usageLimit: number
  usedCount: number
  status: number // 优惠券状态：1-有效，2-无效，3-已过期
  validFrom: number // 有效时间起始
  validTo: number // 有效时间结束
  creator: UserMinDTO
  createdAt: number
  updatedAt: number
  applicableMemberPlans: Array<CouponMemberPlanDTO> // 优惠券中的会员折扣配置
}

// 优惠券中的会员折扣配置
export interface CouponMemberPlanDTO {
  id: string
  memberPlanId: string // 对应的会员方案id
  discountType: number // 折扣方式 0 - 固定金额折扣  1 - 百分比折扣
  discountPercent: number // 0 - 折扣比例 如75 为七五折，原价的70%
  discountAmount: number // 1 - 折扣金额，减去 x 分
  status: number // 优惠券状态：1-有效，2-无效，3-已过期
}

// 已经被领取的优惠券
export interface CouponUsageDTO {
  id: string
  coupon: CouponDTO
  user: UserMinDTO
  orderId: string
  orderAmount: number
  discountAmount: number
  state: number
  scene: string
  expiredAt: number
  usedAt: number
  createdAt: number
  updatedAt: number
}

export interface GetCouponCommand {
  couponId: string
}

export function getCoupon(couponCommand: GetCouponCommand) {
  return netClient.request<CommonResponse<any>>(GET_COUPON, 'post', couponCommand)
}

const _globalShowPhoneBind = useLocalStorage<boolean>(CACHE_KEY_SHOW_PHONE_BIND, false)
export const globalShowPhoneBind = _globalShowPhoneBind

const _globalShowThanksExceed = useLocalStorage<boolean>(CACHE_KEY_SHOW_THANKS, false)
export const globalShowThanksExceed = _globalShowThanksExceed

// export const globalShowZyDialog = useLocalStorage(CACHE_KEY_SHOW_ZHONGYUAN, false)

const _globalShowZyDialog = ref<boolean>(false)
export const globalShowZyDialog = _globalShowZyDialog

export const isLifelongMember = computed(() => {
  const membership = getCurrentUser().value?.member
  if (!membership || membership.state !== 1) {
    return false
  }

  const expireDate = membership.expireDate
  if (!expireDate) {
    return false
  }

  // 计算10年后的日期时间戳（毫秒）
  const tenYearsLater = Date.now() + 20 * 365 * 24 * 60 * 60 * 1000

  // 如果 expireDate 大于 10 年后的时间，则认为是终身会员
  return expireDate > tenYearsLater
})

export interface RenewMention {
  isClose: boolean
}

const _renewMention = useLocalStorage<Record<string, RenewMention>>(CACHE_KEY_SHOW_RENEW_MENTION, {
  // 30-15天区间
  period_30_15: {
    isClose: false
  },
  // 15-7天区间
  period_15_7: {
    isClose: false
  },
  // 7-1天区间，每天提醒一次
  '7days': {
    isClose: false
  },
  '6days': {
    isClose: false
  },
  '5days': {
    isClose: false
  },
  '4days': {
    isClose: false
  },
  '3days': {
    isClose: false
  },
  '2days': {
    isClose: false
  },
  '1days': {
    isClose: false
  },
  '0days': {
    isClose: false
  },
  expired: {
    isClose: false
  }
})
export const renewMention = _renewMention

export const getCouponByScene = (scene: string) => {
  return netClient.request<CommonResponse<CouponUsageDTO>>(GET_COUPON_BY_SCENE, 'get', { scene: scene })
}
export const giveCouponByScene = (scene: string) => {
  return netClient.request<CommonResponse<CouponUsageDTO>>(GIVE_COUPON_By_SECNE, 'get', { scene: scene })
}
